<template>
  <transition name="fade-wrap">
    <div class="search-box" v-if="searchFlag">
      <div class="top-box">
        <div class="first-top"></div>
        <div :class="showStyle === 0 ? 'style0-sj-ipt sj-ipt' : ' style1-sj-ipt sj-ipt'">
          <input type="text" class="ipt" :placeholder="languageOption.searchByTitle" v-model.trim="val" />
          <div class="sbg" @click="searchClick">{{ languageOption.search }}</div>
        </div>
        <div class="three-child" @click="close"></div>
      </div>
      <div class="content">
        <div class="content-box" v-if="searchList.length > 0">
          <dl v-for="(item, index) in searchList" :key="index">
            <dt>
              <img :src="item.coverUrl" alt="" @click="toGo(item.id, item)" />
            </dt>
            <dd v-html="item.title || item.name" class="title_dd"></dd>
          </dl>
        </div>
        <div v-else class="boxTwo">{{ languageOption.noDataAvailable }}</div>
      </div>
    </div>
  </transition>
</template>

<script>
import { isPureNum } from '@/utils'
import { setEncryption } from '@/utils'
export default {
  name: 'searchBox',
  data() {
    return {
      searchFlag: false,
      val: '',
      decryption_id: isPureNum(this.$route.query.id)
    }
  },
  props: {
    showStyle: Number,
    searchList: {
      type: Array,
      default: function() {
        return []
      }
    },
    libSearch: String,
    openMode: { default: 0 },
    language: { default: 0 }
  },
  computed: {
    languageOption() {
      return this.$store.state.config.languageOptions[this.language]
    }
  },
  watch: {
    val(newValue) {
      if (newValue === '') {
        this.$emit('close')
      }
    },
    searchList(newList) {
      if (newList.length > 0) {
        if (this.libSearch == '图书馆搜索') {
          newList.forEach((item) => {
            item.name = item && item.name.replace(/<span\s*[^>]*>(.*?)<\/span>/gi, '$1')
            item.name = item && item.name.replace(new RegExp(this.val, 'g'), '<span style="color: #f5c084">' + this.val + '</span>')
          })
        } else {
          newList.forEach((item) => {
            item.title = item && item.title.replace(/<span\s*[^>]*>(.*?)<\/span>/gi, '$1')
            item.title = item && item.title.replace(new RegExp(this.val, 'g'), '<span style="color: #f5c084">' + this.val + '</span>')
          })
        }
      }
    }
  },
  methods: {
    close() {
      this.searchFlag = false
      this.val = ''
      this.$emit('close')
    },
    searchClick() {
      this.$emit('searchClick', this.val)
    },
    toGo(id, obj) {
      if (obj.readModel === -2) {
        if (this.openMode == 0) {
          let url = obj.url
          if (url.indexOf('?') !== -1) {
            url += '&linkReturn=1'
          } else {
            url += '?linkReturn=1'
          }
          if (url.search('elecPublish/index.html') === -1) {
            window.location.href = url
            return
          } else {
            let exp = new RegExp('(http|https):', 'g')
            url = url.replace(exp, window.location.protocol)
          }

          let ifReload = url.substr(url.indexOf('?', 10)) == '?linkReturn=1'
          window.location.href = url
          if (this.libSearch == '图书馆搜索') {
            this.$store.commit('config/LIB_CASE_JUMP', url)
          } else {
            this.$store.commit('config/BOOK_CASE_JUMP', url)
          }
          if (!ifReload) {
            window.location.reload()
          }
        } else {
          window.open(obj.url, '_blank')
        }
      } else {
        if (this.libSearch == '图书馆搜索') {
          const encryption_id = setEncryption(id.slice(5))
          if (id.includes('album')) {
            this.$router.push({ path: '/bookshelfdetail', query: { id: encryption_id, form: 'booklibdetai', libId: this.$route.query.id, openMode: this.openMode } })
          } else if (id.includes('ebook')) {
            this.$router.push({ path: '/content', query: { id: encryption_id, form: 'booklibdetai', libId: this.$route.query.id, openMode: this.openMode } })
          }
        } else {
          const encryption_id = setEncryption(id)
          this.$store.commit('edit/UPDATE_EDIT_HEADER_TYPE', 'catalog')
          this.$router.push({ path: '/content', query: { id: encryption_id, form: 'bookshelfdetai', shelfId: this.$route.query.id, libId: this.$route.query.libId, openMode: this.openMode } })
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.search-box {
  width: 100%;
  height: 100%;
  position: relative;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.85);
  z-index: 15;
  .top-box {
    width: 100%;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: space-around;
    .style1-sj-ipt {
      background-color: #fff;
      border: 1px solid #fff;
      color: #000;
      .ipt {
        width: 175px;
        height: 24px;
        border: 0;
        outline: none;
        padding-left: 5px !important;
        background-color: #fff;
        color: #000;
      }
      input::placeholder {
        color: #c4c4c4;
      }
      .sbg {
        color: #000;
        width: fit-content;
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
    .style0-sj-ipt {
      background-color: #6b2d00;
      border: 1px solid #6b2d00;
      color: #fff;
      overflow: hidden;
      .ipt {
        width: 175px;
        height: 24px;
        border: 0;
        outline: none;
        padding-left: 5px !important;
        background-color: #6b2d00;
        color: #fff;
      }
      input::placeholder {
        color: #fff;
      }
      .sbg {
        color: #fff;
        width: 50px;
        height: 26px;
        text-align: center;
        line-height: 26px;
        background-color: #44271d;
      }
    }
    .sj-ipt {
      width: 230px;
      height: 26px;
      line-height: 60px;
      display: flex;
      font-size: 14px;
      border-radius: 5px;
      padding: 0 0 0 3px;
    }
    .first-child {
      width: 24px;
      height: 24px;
    }
    .three-child {
      width: 24px;
      height: 24px;
      background: url('~@imgs/close@2x.png') no-repeat center center;
      background-size: cover;
      cursor: pointer;
    }
  }
  .content {
    width: 100%;
    height: calc(100% - 50px);
    .content-box {
      width: 340px;
      height: 100%;
      margin: 0 auto;
      overflow: auto;
      dl {
        width: 100%;
        height: 152px;
        display: flex;
        justify-content: space-around;
        align-items: center;
        dt {
          width: 152px;
          height: 152px;
          display: flex;
          justify-content: space-around;
          align-items: center;
          img {
            max-width: 100%;
            max-height: 100%;
          }
        }
        dd {
          font-size: 14px;
          width: 188px;
          height: 100%;
          color: #fff;
          padding-top: 18%;
        }
        .isInclude {
          color: #fff !important;
        }
      }
    }
    .boxTwo {
      width: 100%;
      height: 100%;
      font-size: 20px;
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
.fade-wrap-enter-active,
.fade-wrap-leave-active {
  transition: all 0.5s;
}
.fade-wrap-enter,
.fade-wrap-leave-to {
  transform: translateX(-375px);
  opacity: 0;
}
</style>
